export default {"src":"/login-app/[GIT_HASH]/_next/static/media/key_command.c02401e6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};